import React, { useState, useEffect } from "react";
import "../assets/templates/LeadInText.css";
import LessonInstruction from "../containers/instruction/LessonInstruction";

import { useRegisterProgress } from "../hooks/useRegisterProgress";

const LeadInText = (props) => {
  const [data, setData] = useState([]);
  const [buttonMsg, setButtonMsg] = useState('Check');

  const { blockData, contentIndex, audioUrl } = props;

  // hook useRegisterProgress.
  const { registerProgress } = useRegisterProgress(
    blockData.block_id,
    props.lessonId,
    blockData.sectionId,
    blockData.section,
    blockData.num,
    props.totalIndexes,
    "lead_in_text"
  );

  // Function to shuffle the array
  const shuffle = (a) => {
    let j, x, i;
    for (i = a.length - 1; i > 0; i--) {
      j = Math.floor(Math.random() * (i + 1));
      x = a[i];
      a[i] = a[j];
      a[j] = x;
    }
    return a;
  };

  const handleConcluirClick = async () => {    
    try {
      await registerProgress();  
    } catch (error) {
      console.log("An error occurred during the process of registration: "
        , error);
    }
  };

  // Function to get the words
  const getWords = () => {
    let dataYes = props.blockData.complement.yes;
    let dataNo = props.blockData.complement.no;
    let arrYes = [];
    let arrNo = [];
    let concatObj = [];
    for (let i = 0; i < dataYes.length; i++) {
      arrYes.push({
        value: dataYes[i],
        status: "yes",
        originalColor: "green",
        selectedColor: "black",
        clicked: false
      });
    }
    for (let j = 0; j < dataNo.length; j++) {
      arrNo.push({
        value: dataNo[j],
        status: "no",
        originalColor: "red",
        selectedColor: "black",
        clicked: false
      });
    }
    concatObj = arrNo.concat(arrYes);
    setData(shuffle(concatObj));
    setButtonMsg('Check');
  };

  // useEffect to mimic componentDidMount and componentDidUpdate
  useEffect(() => {
    getWords();
  }, [props.blockData]);

  const changeColor = async (itemValue) => {
    let newData = data.map(item => {
      if (item.value === itemValue) {
        return { ...item, clicked: !item.clicked };
      }
      return item;
    });
    setData(newData);
  };

  const checkOrder = async () => {
    let updatedData = data.map(item => ({
      ...item,
      selectedColor: item.originalColor,
      clicked: true
    }));
    setData(updatedData);    
    setButtonMsg('Done');
    await handleConcluirClick();

    if (buttonMsg === 'Done') {
      getWords();
      props.step('forward', true);
    }
  };

  // Set background color
  const bgColor = blockData.content[contentIndex].type === "instruction" ? "new-bg-color" : "";
  const containerClasses = `default-card container ${bgColor}`;

  return (
    <div className={containerClasses}>
      {blockData.content[contentIndex].type === "instruction" ? (
        <>
          <LessonInstruction
            instructionText={blockData.content[contentIndex].instruction}
            audioUrl={audioUrl}
          />
        </>
      ) : (
        <div>
          <div
            className="listen-drag-check-maze"
            onClick={() => {
              checkOrder();
            }}
          >
            {buttonMsg}
          </div>
          <div className="alignItens">
            <img
              alt="LeadInText"
              src={`${process.env.REACT_APP_CLOUDFRONT_DNS}/media/images/${blockData.complement.image.img}`}
              className="leadInTextImg"
              style={{
                maxHeight: "300px",
                maxWidth: "300px",
              }}
            />
          </div>
          <div className="row">
            {data.map((item, i) => (
              <div
                className="col-md-2"
                style={{ marginTop: "10px", marginLeft: 'auto', marginRight: 'auto' }}
                key={i}
              >
                <button
                  className="btn btn-default randButton"
                  onClick={async () => {
                    if (buttonMsg === 'Check') {                     
                      await changeColor(item.value);
                    }
                  }}
                  style={{
                    border: "solid 3px",
                    borderColor: item.clicked ? item.selectedColor : "white",
                    minWidth: '100px'
                  }}
                >
                  {item.value}
                </button>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default LeadInText;
